/**
 * Created by Administrator on 2017/12/7.
 */

import header from './header2.vue'
import editor from './ueditor.vue'

export default {header, editor}




// WEBPACK FOOTER //
// ./src/components/index.js